import { cellRenderPopupActM15B } from '../../PopupActMVP/functionPopupAct';
import { cellRenderParseData, cellRenderStatusAct } from '../../../utils/functions';

const columnDataGridRecyclingM15B = [
  {
    dataField: 'm15b',
    caption: 'М-15B',
    cellRender: cellRenderPopupActM15B,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'm15bNumId',
    caption: 'id М-15B',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'm15bDocStatus',
    caption: 'id М-15B Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'm15bDate',
    caption: 'Дата М-15B',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'm15bDocStatusDescr',
    caption: 'Статус акта М-15',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  }
];

export default columnDataGridRecyclingM15B;
